/**
 * Splits a stat like "1.4M", "99.98%", "148ms", "6 weeks" into its numeric
 * part and affixes so the number can count up while the affixes stay put.
 */
export function parseStatValue(raw: string): {
  prefix: string
  value: number
  decimals: number
  suffix: string
} | null {
  const match = /^([^0-9]*)([0-9]+(?:[.,][0-9]+)?)(.*)$/.exec(raw.trim())
  if (!match) return null
  const [, prefix = '', numberText = '', suffix = ''] = match
  const normalized = numberText.replace(',', '.')
  const decimals = normalized.includes('.') ? (normalized.split('.')[1]?.length ?? 0) : 0
  return { prefix, value: Number(normalized), decimals, suffix }
}
